function l(...c) {
  const t = (r) => r && typeof r == "object";
  function i(r, a) {
    return Object.keys(a).forEach((s) => {
      const u = r[s], o = a[s];
      Array.isArray(u) && Array.isArray(o) ? r[s] = u.concat(o) : t(u) && t(o) ? r[s] = i(
        Object.assign({}, u),
        o
      ) : r[s] = o;
    }), r;
  }
  if (c.length < 2)
    throw new Error("This function expects at least 2 objects to be provided");
  if (c.some((r) => !t(r)))
    throw new Error('All values should be of type "object"');
  const e = c.shift();
  let n = null;
  for (; n = c.shift(); )
    i(e, n);
  return e;
}
const f = {
  app_id: null,
  app_url: null,
  authentication: null,
  headers: { "Content-Type": "application/json" },
  middleware: null,
  params: {},
  queries: {
    authentication: {
      _defaults: { base_url: "/v1/authentication" },
      accountCancel: { method: "POST", url: "/account/cancel" },
      accountCreate: { method: "POST", url: "/account/create" },
      accountPrepare: { method: "POST", url: "/account/prepare" },
      accountVerify: { method: "POST", url: "/account/verify" },
      refresh: { method: "POST", url: "/token/refresh" },
      signout: { url: "/signout" }
    }
  }
};
class d {
  constructor(t = {}) {
    if (this.config = l(f, t), !this.config.app_id)
      throw new Error('Config variable "app_id" is missing or empty');
    if (!this.config.app_url)
      throw new Error('Config variable "app_url" is missing or empty');
  }
  createUrl(t, i = {}) {
    let e = {};
    if (t) {
      const [n, r] = t.split(".");
      if (e.endpoint = r, e.method = "GET", e.query = this.config.queries[n][r], e.type = n, !this.config.queries[n] || !this.config.queries[n][r])
        throw Error(
          `Type (${n}) and/or endpoint (${r}) does not exist in "queries"`
        );
      if (e.query.method && (e.method = e.query.method), this.config.middleware && typeof this.config.middleware == "function") {
        const a = this.config.middleware({
          action: "createUrl",
          endpoint: e.endpoint,
          method: e.method,
          query: e.query,
          type: e.type
        });
        a != null && a.params && (i = { ...i, ...a == null ? void 0 : a.params });
      }
      this.config.queries[n][r].params && (i = { ...i, ...this.config.queries[n][r].params }), e.base_url = `${this.config.app_url}${this.config.queries[n]._defaults.base_url}${e.query.url}`, e.url = this.urlParams(e.base_url, {
        app_id: this.config.app_id,
        ...i
      });
    }
    return e;
  }
  async fetch(t = {}) {
    var n, r, a, s, u, o;
    t = l(
      {
        headers: ((n = this == null ? void 0 : this.config) == null ? void 0 : n.headers) || {},
        params: ((r = this == null ? void 0 : this.config) == null ? void 0 : r.params) || {}
      },
      {
        body: null,
        headers: {},
        method: null,
        params: {},
        url: null
      },
      t
    );
    let i = {};
    if (t.body && (t.body = JSON.stringify(t.body)), (s = (a = this == null ? void 0 : this.config) == null ? void 0 : a.authentication) != null && s.getToken) {
      const h = this.config.authentication.getToken();
      t.headers.Authorization = `Bearer ${h}`;
    }
    const e = await fetch(t.url, {
      body: (t == null ? void 0 : t.body) || null,
      headers: t.headers,
      method: t.method
    });
    return i = await e.json(), e != null && e.ok || (e.status === 401 && ((o = (u = this == null ? void 0 : this.config) == null ? void 0 : u.authentication) != null && o.signOut) && this.config.authentication.signOut({ status: e.status }), i._response = e), i;
  }
  handleParams(t, i = null, e = new URLSearchParams()) {
    for (const n in t) {
      const r = i ? `${i}[${n}]` : n, a = t[n];
      a !== null && (Array.isArray(a) || typeof a == "object") ? this.handleParams(a, r, e) : e.append(r, a);
    }
    return e;
  }
  async request(t, i = {}) {
    const { method: e, url: n } = this.createUrl(t, i.params);
    return await this.fetch({ ...i, method: e, url: n });
  }
  urlParams(t, i) {
    let e = new URL(t);
    return this.handleParams(i, null, e.searchParams), e.toString();
  }
}
export {
  d as default
};
//# sourceMappingURL=http-client.es.js.map
